<div class="code-management-container">
  <!-- Header -->
  <div class="page-header">
    <h1 class="page-title">{{ title }}</h1>
  </div>

 <div class="filters-actions-row">
    <app-filter-dropdowns
      (dropdownsEvent)="onFiltersSelected($event)">
    </app-filter-dropdowns>
 
    <div class="buttons-row">
      <div class="flex items-center gap-2 flex-wrap flex-1">
        <button
          pButton
          type="button"
          icon="pi pi-filter"
          [label]="filterButtonLabel"
          class="p-button-outlined"
          [ngClass]="{'filter-button-active': isFilterPanelOpen || hasActiveFilters}"
          [disabled]="!isPlanSelected"
          (click)="toggleFilters()">
        </button>
        
        <app-code-filters
          #filterChips
          [selectedFilters]="selectedFilters"
          (filtersApplied)="onCodeFiltersApplied($event)"
          [showOnlyChips]="true"
          [refreshTrigger]="filterRefreshTrigger">
        </app-code-filters>
      </div>
 
      <div class="action-buttons">
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Add New Code"
          *accessView="['CodesMgmt.HCPCS.Write']"
          aria-label="Add New Code"
          [disabled]="isAddCodeDisabled"
          [attr.aria-disabled]="isAddCodeDisabled"
          (click)="addNewCode()">
        </button>
      </div>
    </div>
  </div>

  <app-code-filters
    #filterPanel
    [selectedFilters]="selectedFilters"
    (filtersApplied)="onCodeFiltersApplied($event)"
    [showOnlyPanel]="true">
  </app-code-filters>

  <app-code-list
    [filters]="selectedFilters"
    [codeFilters]="codeFilters"
    >
  </app-code-list>

  <!-- Add Code Component -->
  <app-add-code 
    *ngIf="showAddCode"
    [selectedFilters]="selectedFilters"
    (cancel)="onCancelAddCode()"
    (save)="onSaveCode($event)">
  </app-add-code>
</div>
